<template>
  <div class="animated fadeIn">
    <b-card>
      <b-row>
        <b-col cols="12">
          <div slot="header">
            <i class="icon-note"></i>Cheque
            <a
              target="_blank"
              class="pull-right btn btn-sm btn-success text-white"
              style="cursor: pointer"
              @click="print()"
            >
              <i class="fa fa-print" /> Imprimir
            </a>

          </div>
        </b-col>
        <b-col cols="12">
          <br>
          <visor-pdf v-show="cargado" :url="urlpdf" />
        </b-col>

      </b-row>
    </b-card>
  </div>
</template>

<script>
import VisorPdf from "@/components/VisorPdf";

export default {
  name: "pdf-cheques",
   components: {
    VisorPdf
  },

  data() {
    return {
      id: parseInt(this.$route.params.id),
      nombre: this.$route.params.name,
      urlpdf:'',
      cargado:false
    };
  },
  methods: {
    cargarPdf() {
      if(this.id){
        let url_pdf_api =process.env.VUE_APP_API_REPORTES_URL;
        this.urlpdf =   `${url_pdf_api}pdf/cheque?id=${this.id}`;
        this.cargado = true;
      }
    },
    async print(){
      try {
        // eslint-disable-next-line no-undef
        const response = await axios.post(this.urlpdf, {},{responseType: 'blob'});
        const url = window.URL.createObjectURL(new Blob([response.data],{type: "application/pdf"}));
        window.open(url);
      } catch(error){
        console.log("aca anda");
        console.log(error);
      }
    }
  },
  created() {
    this.cargarPdf();
  }
};
</script>
<style lang="css">

</style>
